<template>
    <div  style=" text-align: center;">
        <div style="">{{ $t("dashboard.health_progress.title") }}</div>
        <div id="pager">

            <div v-for="(d, i) in intervals" :key="i" v-show="i == selectedInterval">
                <span style=" padding:10px; user-select:none;cursor:pointer" v-show="selectedInterval != 0"
                    @click="selectedInterval--"> &lt; </span>
                {{ $t(`dashboard.health_progress.${d.label}`) }}
                <span style="padding:10px;user-select:none;cursor:pointer"
                    v-show="selectedInterval != intervals.length - 1" @click="selectedInterval++"> &gt;</span>
            </div>
        </div>
    </div>
</template>

 
<script>
import * as am5 from '@amcharts/amcharts5';
import colorLib from '../../util/colorLib';
import dayjs from 'dayjs';

export default {
    name: 'DateInput',
    data() {
        return {
            startDate: new Date(),
            endDate: new Date(),
            unit: "day",
            xAxis: '',
            selectedInterval: 1,
            intervals: [
                { label: 'last_24h', unit: 'hour', hours: 24, format: 'dd HH:ss', chartIntervalUnit: 'second' },
                { label: 'last_7_days', unit: 'day', hours: 24 * 6, format: 'DD/MM/YYYY', chartIntervalUnit: 'minute' },
                { label: 'last_1_month', unit: 'day', hours: 24 * 30, format: 'DD MMM', chartIntervalUnit: 'minute' },
                { label: 'last_3_month', unit: 'week', hours: 24 * 30 * 3, format: 'DD MMM', chartIntervalUnit: 'hour' },
                { label: 'last_6_month', unit: 'week', hours: 24 * 30 * 6, format: 'DD MMM', chartIntervalUnit: 'hour' },
                { label: 'last_year', unit: 'month', hours: 24 * 30 * 12, format: 'MMM YYYY', chartIntervalUnit: 'hour' },
            ]
        };
    },

    methods: {
        getColor(o) {
            return am5.color(colorLib.getAlarmColorByOrder(o));
        },
        async loadData() {
            let unit = this.intervals[this.selectedInterval].unit;
            let hours = this.intervals[this.selectedInterval].hours;
            let start = dayjs().subtract(hours, 'hour').format('YYYY-MM-DDTHH:mm:ss');
            let end = dayjs().format('YYYY-MM-DDTHH:mm:ss');

            this.startDate = start;
            this.endDate = end;
            this.unit = unit;
            const interval = this.intervals[this.selectedInterval]
            this.$emit('setDate', start, end, unit, interval)
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        "selectedInterval": function (val) {
            this.loadData();
        }
    }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pager .el-carousel__arrow {
    width: 10px;
    height: 10px
}
</style>